import { render, staticRenderFns } from "./CourseTransferSelectStudent.vue?vue&type=template&id=667b915b"
import script from "./CourseTransferSelectStudent.vue?vue&type=script&lang=js"
export * from "./CourseTransferSelectStudent.vue?vue&type=script&lang=js"
import style0 from "./CourseTransferSelectStudent.vue?vue&type=style&index=0&id=667b915b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports